import { useEffect, useState, useCallback } from 'react';
import * as svc from '../lib/activeGameService';

export default function useActiveGame() {
  const [list, setList] = useState(() => svc.getActiveGames());

  useEffect(() => {
    const handler = () => setList(svc.getActiveGames());
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const create = useCallback((meta) => {
    const id = svc.createActiveGame(meta);
    setList(svc.getActiveGames());
    return id;
  }, []);

  const update = useCallback((id, patch) => {
    const updated = svc.updateActiveGame(id, patch);
    setList(svc.getActiveGames());
    return updated;
  }, []);

  const remove = useCallback((id) => {
    svc.removeActiveGame(id);
    setList(svc.getActiveGames());
  }, []);

  const get = useCallback((id) => svc.getActiveGame(id), []);

  const hydrate = useCallback((id) => svc.hydrateForGame(id), []);

  return { list, create, update, remove, get, hydrate };
}
